export default {
    getHeaderFields: state => state.headerFields,
    getAlaCarteHeaderFields: state => state.alaCarteHeaderFields,
    getFormActions: state => state.formActions,
    getSearchFields: state => state.searchFields,
    getActions: state => state.actions,
    getAlacarteActions: state => state.alacarteActions,
    getAdditionalTableConfig: state => state.additionalTableConfig,
    getRowActions: state => state.rowActions,
    isAlaCarteGridOpen: state => state.alaCarteGridIsOpen,
    isFixedGridOpen: state => state.fixedGridIsOpen
}
